import Swiper from 'swiper';
import SectionTitleReveal from '../common/section-title-reveal';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Pagination, Navigation } from 'swiper/modules';
import { bindSwiperNavigationA11y } from '../common/syncSwiperNavigationA11y';

export default class Timeline {

    constructor() {
        this.sections = document.querySelectorAll('.block-timeline');
        this.instances = [];
        this.handleResize = this.debounce(this.rebuild.bind(this), 300);

        this.ready();
        window.addEventListener('resize', this.handleResize);
    }

    debounce(fn, delay) {
        let timer;
        return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => fn.apply(this, args), delay);
        };
    }

    rebuild() {
        this.instances.forEach(obj => {
            obj.main?.destroy(true, true);
        });
        this.instances = [];
        this.ready();
    }

    ready() {
        if (this.sections.length === 0) return;

        this.sections.forEach(section => {

            const slider = section.querySelector('.swiper');
            if (!slider) return;

            const desktopNavigationNext = section.querySelector('.navigation-desktop .slider-button-next');
            const desktopNavigationPrev = section.querySelector('.navigation-desktop .slider-button-prev');
            const desktopPagination = section.querySelector('.navigation-desktop .swiper-pagination');
            const mobileNavigationNext = section.querySelector('.navigation-mobile .slider-button-next');
            const mobileNavigationPrev = section.querySelector('.navigation-mobile .slider-button-prev');
            const mobilePagination = section.querySelector('.navigation-mobile .swiper-pagination');

            const swiperInstance = new Swiper(slider, {
                modules: [Pagination, Navigation],
                spaceBetween: 48,
                grabCursor: true,
                watchSlidesProgress: true,
                breakpoints: {
                    0: {
                        slidesPerView: 1,
                        slidesOffsetBefore:28,
                        slidesOffsetAfter:28,
                        navigation: mobileNavigationNext && mobileNavigationPrev ? {
                            nextEl: mobileNavigationNext,
                            prevEl: mobileNavigationPrev,
                        } : false,
                        pagination: mobilePagination ? {
                            el: mobilePagination,
                            clickable: true,
                        } : false,
                    },
                    1024: {
                        slidesPerView: 'auto',
                        slidesOffsetAfter:400,
                        navigation: desktopNavigationNext && desktopNavigationPrev ? {
                            nextEl: desktopNavigationNext,
                            prevEl: desktopNavigationPrev,
                        } : false,
                        pagination: desktopPagination ? {
                            el: desktopPagination,
                            clickable: true,
                        } : false,
                    }
                }
            });

            bindSwiperNavigationA11y(swiperInstance);

            this.instances.push({ main: swiperInstance });
        });
    }
}

new SectionTitleReveal('.block-timeline');

if (document.querySelector('.block-timeline')) {
    new Timeline();
}
